<template>
  <div class="page-content">
    <page-template ref="detailTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   @searchReset="searchReset"
    ></page-template>
    <el-dialog
      id="bill-show-style"
      title="小票预览"
      :visible.sync="billShow"
      :close-on-click-modal="false"
    >
      <list-bill-view :tableOptions="billReportListColumns"
                      :columns="billReportListColumns.columns"
                      :list="billReportListColumns.list"
                      :title="billReportListColumns.title"
                      :foot="billReportListColumns.foot"></list-bill-view>
    </el-dialog>
    <el-dialog
      id="member-show-style"
      title="小票预览"
      :visible.sync="memberShow"
      :close-on-click-modal="false"
    >
      <list-member-view :tableOptions="integralExchangeListColumns"
                        :columns="integralExchangeListColumns.columns"
                        :list="integralExchangeListColumns.list"
                        :title="integralExchangeListColumns.title"
                        :foot="integralExchangeListColumns.foot"></list-member-view>
    </el-dialog>
  </div>
</template>
<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';
import listBillView from "@/components/template/listBillView"
import listMemberView from "@/components/template/listMemberView"
import userPower from '@/mixin/userPower'

export default {
  mixins: [userPower],
  components: {
    pageTemplate, listBillView, listMemberView
  },
  data() {
    return {
      billShow: false,
      memberShow: false,
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [{label: '业务单号', prop: 'orderNo', type: 'input', isFuzzy: true, placeholder: '请输入业务单号'}],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            // defaultValue: '10',
            span: 24
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            span: 6,
            data: [],
            isHasAll: true,
            change: this.storeChange,
            url: api.system.seStore
          },
          {
            label: "商品类别",
            type: 'cascaderMultiple',
            prop: 'goodsCategoryIds',
            valueKey: 'value',
            data: [],
            span: 6,
            change: this.typeChange,
            url: api.archives.getCategoryTree,
          },
          {
            label: '供应商',
            type: 'select',
            prop: 'supplierId',
            data: [],
            span: 6,
            // url: api.archives.supplier,
          },

          {
            label: '商品品牌',
            prop: 'brandId',
            type: 'select',
            span: 6,
            data: [],
            // url: api.archives.brand,
            placeholder: '请输入商品品牌',
          },
          {
            label: '条码',
            prop: 'barCode',
            type: 'input',
            span: 6,
            placeholder: '请输入商品条码'
          },
          {
            label: '商品名称',
            prop: 'goodsName',
            type: 'input',
            span: 6,
            placeholder: '请输入商品名称'
          },

          {
            label: '业务单号',
            prop: 'orderNo',
            type: 'input',
            span: 6,
            placeholder: '请输入业务单号'
          },
          {
            label: '业务类型',
            prop: 'businessType',
            type: 'select',
            span: 6,
            data: this.$utils.getCacheStatus('weWarehouseOrderV2.businessType')
          },


          // {
          //   label: "仓库",
          //   type: "select",
          //   prop: "warehouseId",
          //   url: api.warehouse.warehouse,
          //   param: {relateType: this.$utils.getSysUser().storeId?20:10},
          //   data: [],
          //   span: 6,
          // },
          {
            label: '小计金额',
            prop: 'TotalPrice',
            type: 'numberRange',
            span: 12
          },
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '打印',
          code: 'print',
        },
        {
          label: '导出',
          code: 'export',
          callback: this.exportExcel
        },
      ],
      // 表格信息配置
      tableOptions: {
        showSummary: true,
        param: {
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        },
        summaryColumns: ['enterGoodsNum', 'outGoodsNum'],
        indexShow: true,//是否显示索引
        columns: [
          {
            label: '仓库',
            prop: 'warehouseName',
            width: '190',
            align: 'center'
          },
          {
            label: '操作类型',
            prop: 'operationType',
            width: '120',
            align: 'center',
            enumData: this.$utils.getCacheStatus('weWarehouseOrder.operationType')
          },
          {
            label: '业务类型',
            prop: 'businessType',
            width: '130',
            align: 'center',
            enumData: this.$utils.getCacheStatus('weWarehouseOrderV2.businessType')
          },
          {
            label: '业务单号',
            prop: 'orderNo',
            width: '240',
            align: 'center',
            callback: this.goOrderDetail,
          },
          {
            label: '条码',
            prop: 'barCode',
            width: '160',
            align: 'center'
          }, {
            label: '商品名称',
            prop: 'goodsName',
            width: '140',
            align: 'center'
          },
          {
            label: '规格',
            prop: 'specs',
            width: '90',
            align: 'center'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '90',
            align: 'center'
          },
          {
            label: '类别',
            prop: 'categoryName',
            width: '90',
            align: 'center'
          },
          {
            label: '品牌',
            prop: 'brandName',
            width: '100',
            align: 'center'
          },
          {
            label: '成本价',
            prop: 'purchasePrice',
            width: '90',
            align: 'center'
          },
          {
            label: '单价',
            prop: 'unitPrice',
            width: '90',
            align: 'center'
          },
          {
            label: '进项数量',
            prop: 'enterGoodsNum',
            width: '90',
            align: 'center'
          },
          {
            label: '出项数量',
            prop: 'outGoodsNum',
            width: '90',
            align: 'center'
          },
          {
            label: '小计金额',
            prop: 'totalPrice',
            width: '90',
            align: 'center'
          },
          {
            label: '业务日期',
            prop: 'createDttm',
            width: '150',
            align: 'center'
          },
          {
            label: '备注',
            prop: 'remarks',
            width: '150',
            align: 'center'
          },
        ],
        url: api.warehouse.warehouseOrder
      },
      //采购入库详情
      stockDetailColumns: {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png',
          },
          right: '200px',
          top: '30px',
        },
        span: 8,
        labelWidth: '130',
        columns: [
          {
            label: '业务单号',
            type: 'input',
            prop: 'orderNo',
          },
          {
            label: '采购门店',
            prop: 'storeName',
          },
          {
            label: '供应商',
            type: 'select',
            prop: 'supplierName',
          },
          {
            label: '门店仓库',
            type: 'select',
            prop: 'warehouseName',
          },
          {
            label: '经手人',
            prop: 'handler',
          },
          {
            label: '采购订单',
            prop: 'purchaseOrderNo',
          },
          {
            label: '来货日期',
            prop: 'goodsArriveDttm',
          },
          {
            label: '备注',
            prop: 'remarks',
          },
        ],
        tablesProp: {
          pcGoodsMapList: {
            url: api.purchase.goods + "/page",
            height: this.detailHeight,
            showSummary: true,
            indexShow: true,
            tableName: 'pcGoodsMapList',
            summaryColumns: ['goodsNum', 'giveGoodsNum', 'totalPrice'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '150',
                align: 'center',
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                width: '90',
                align: 'center',
              },
              {
                label: '规格',
                prop: 'specs',
                width: '60',
                align: 'center',
              },
              {
                label: '单位',
                width: '60',
                prop: 'unitName',
                align: 'center',
              },
              {
                label: '自编码',
                width: '120',
                prop: 'artNo',
                align: 'center',
              },
              // {
              //   label: '档案进价',
              //   width: '90',
              //   prop: 'buyPrice',
              //   align: 'center',
              // },
              {
                label: '实际入库数量',
                width: '130',
                prop: 'goodsNum',
                align: 'center',
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsNum',
                align: 'center',
              },
              {
                label: '进价',
                width: '120',
                prop: 'price',
                align: 'center',
              },
              {
                label: '折扣',
                width: '90',
                prop: 'discountRate',
                align: 'center',
              },
              {
                label: '小计金额',
                width: '120',
                prop: 'totalPrice',
                align: 'center',
              },
              {
                label: '生产日期',
                prop: 'produceDttm',
                width: '220',
                align: 'center',
              },
              {
                label: '零售价',
                width: '120',
                prop: 'retailPrice',
                align: 'center',
              },
              {
                label: '零售金额',
                width: '90',
                prop: 'salesAmount',
                align: 'center',
              },
              {
                label: '采购未入库数量',
                width: '130',
                prop: 'noStorageNum',
                align: 'center',
              },
              {
                label: '系统库存',
                prop: 'inventoryNum',
                width: '90',
                align: 'center',
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '150',
                align: 'center',
              },
            ],
          },
        },
        // 打印的列表
        printTablesProp: {
          pcGoodsMapList: {
            tableName: 'pcGoodsMapList',
            showSummary: true,
            summaryColumns: ['totalPrice'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '150',
                align: 'center',
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                width: '90',
                align: 'center',
              },
              // {
              //   label: '规格',
              //   prop: 'specs',
              //   width: '90',
              //   align: 'center',
              // },
              {
                label: '单位',
                width: '60',
                prop: 'unitName',
                align: 'center',
              },
              // {
              //   label: '自编码',
              //   width: '120',
              //   prop: 'artNo',
              //   align: 'center',
              // },
              {
                label: '零售价',
                width: '120',
                prop: 'retailPrice',
                align: 'center',
              },
              {
                label: '进货价',
                width: '90',
                prop: 'buyPrice',
                align: 'center',
              },
              {
                label: '实际入库数量',
                width: '130',
                prop: 'goodsNum',
                align: 'center',
              },
              {
                label: '采购未入库数量',
                width: '130',
                prop: 'noStorageNum',
                align: 'center',
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsNum',
                align: 'center',
              },
              {
                label: '小计金额',
                width: '120',
                prop: 'totalPrice',
                align: 'center',
              },
            ],
          },
        },
        url: api.purchase.stock,
      },
      //采购退货详情
      purchaseReturnDetailColumns:{
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '100px',
          top: '30px',
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '业务单号',
            type: 'input',
            prop: 'orderNo',
            disabled: true
          },
          {
            label: '采购门店',
            prop: 'storeName',
          }, {
            label: '供应商',
            type: 'select',
            prop: 'supplierName',
          }, {
            label: '仓库名称',
            type: 'select',
            prop: 'warehouseName',
          }, {
            label: '经手人',
            prop: 'handler',
            type: 'input',
          },
          {
            label: '采购入库单',
            type: 'select',
            prop: 'storageOrderNo',
            data: [],
            labelKey: 'orderNo',
          },
          {
            label: '备注',
            type: 'input',
            prop: 'remarks',
          }],
        tablesProp: {
          goodsMapList: {
            url: api.purchase.goods + "/page",
            height:this.detailHeight,
            showSummary:true,
            indexShow: true,
            tableName: "goodsMapList",
            summaryColumns: ['goodsNum', 'giveGoodsNum','totalPrice'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                type: 'more',
                callback: this.getInfo,
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '单位',
                width: '90',
                prop: 'unitName',
                align: "center"
              },
              {
                label: '自编码',
                width: '90',
                prop: 'artNo',
                align: "center"
              },
              // {
              //   label: '档案进价',
              //   prop: 'buyPrice',
              //   align: "center"
              // },
              {
                label: '数量',
                prop: 'goodsNum',
                type: 'inputNumber',
                align: "center",
                change: this.numChange
              },
              {
                label: '赠送数量',
                prop: 'giveGoodsNum',
                type: 'input',
                align: "center"
              },
              {
                label: '进价',
                prop: 'price',
                type: 'input',
                align: "center",
                change: this.priceChange
              },
              {
                label: '小计金额',
                prop: 'totalPrice',
                type: 'input',
                align: "center"
              },
              {
                label: '零售价',
                prop: 'retailPrice',
                align: "center"
              },
              {
                label: '零售金额',
                prop: 'salesAmount',
                align: "center"
              },
              {
                label: '系统库存',
                width: '90',
                prop: 'inventoryNum',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '150',
                align: "center"
              },
            ],
          }
        },
        // 打印的列表
        printTablesProp: {
          goodsMapList: {
            tableName: 'goodsMapList',
            showSummary: true,
            summaryColumns: ['retailPrice', 'salesAmount', 'buyPrice', 'goodsNum'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                type: 'more',
                callback: this.getInfo,
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '自编码',
                width: '90',
                prop: 'artNo',
                align: "center"
              },
              {
                label: '零售价',
                width: '100',
                prop: 'retailPrice',
                align: "center"
              },
              {
                label: '零售金额',
                prop: 'salesAmount',
                align: "center"
              },
              {
                label: '进价',
                prop: 'buyPrice',
                align: "center"
              },
              {
                label: '退货数量',
                prop: 'goodsNum',
                type: 'inputNumber',
                align: "center",
                change: this.numChange
              },
            ],
          },
        },
        url: api.purchase.return
      },
      // 调价单详情
      pdadjapDetailColumns: {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '350px',
          top: '30px'
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
            span: 12,
          },
          // {
          //   label: '门店',
          //   prop: 'storeId',
          //   url: api.system.seStore,
          //   span: 12,
          // },
          {
            label: '调价类别',
            prop: 'types',
            span: 12,
            enumData: this.$utils.getCacheStatus('asPriceAdjustmentOrder.type')
          }, {
            label: '备注',
            prop: 'remarks',
            span: 12
          },
        ],
        tablesProp: {
          adjustmentGoodsMapList: {
            tableName: "adjustmentGoodsMapList",
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '100',
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                width: '100',
              },
              {
                label: '规格',
                prop: 'specs',
                width: '100'
              },
              {
                label: '单位',
                prop: 'unitName',
                width: '100'
              },
              {
                label: '原进货价',
                prop: 'buyPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '进货价',
                type: 'inputNumber',
                prop: 'paBuyPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原零售价',
                prop: 'retailPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '零售价',
                type: 'inputNumber',
                prop: 'paRetailPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原最低零售价',
                prop: 'lowestPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '最低零售价',
                type: 'inputNumber',
                prop: 'paLowestPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原会员价',
                prop: 'vipPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '会员价',
                type: 'inputNumber',
                prop: 'paVipPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原PLUS会员价',
                prop: 'plusVipPrice',
                align: 'center',
                width: '110',
              },
              {
                label: 'PLUS会员价',
                type: 'inputNumber',
                prop: 'paPlusVipPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原批发价',
                prop: 'tradePrice',
                align: 'center',
                width: '110',
              },
              {
                label: '批发价',
                type: 'inputNumber',
                prop: 'paTradePrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原配送价',
                prop: 'deliveryPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '配送价',
                type: 'inputNumber',
                prop: 'paDeliveryPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
              },
            ],
          }
        },
        url: api.archives.priceDadjap
      },
      //批发销售
      salesDetailColumns: {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '100px',
          top: '0',
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
          },
          {
            label: "批发门店",
            prop: "storeName",
          },
          {
            label: '批发客户',
            prop: 'wholesaleCustomerName',
          }, {
            label: '仓库',
            prop: 'warehouseName',
          }, {
            label: '经手人',
            prop: 'salesman',
          }, {
            label: '备注',
            prop: 'remarks',
          }],
        tablesProp: {
          wlWholesaleOrderGoodsMapList: {
            url: api.wholesale.wholesaleQuery + "/page",
            height: this.detailHeight,
            indexShow: true,
            showSummary: true,
            summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
            tableName: "wlWholesaleOrderGoodsMapList",
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '单位',
                width: '90',
                prop: 'unitName',
                align: "center"
              },
              {
                label: '自编码',
                width: '125',
                prop: 'artNo',
                align: "center"
              },
              {
                label: '数量',
                width: '90',
                prop: 'goodsCount',
                align: "center"
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsCount',
                align: "center"
              },
              {
                label: '原价',
                width: '90',
                prop: 'beforePrince',
                align: "center"
              },
              {
                label: '原价金额',
                width: '90',
                prop: 'beforeAmt',
                align: "center"
              },
              {
                label: '折扣',
                width: '90',
                prop: 'discountRate',
                align: "center"
              },
              {
                label: '折扣价格',
                width: '90',
                prop: 'discountPrince',
                align: "center"
              },
              {
                label: '小计金额',
                width: '90',
                prop: 'discountAmt',
                align: "center"
              },
              {
                label: '系统库存',
                width: '90',
                prop: 'inventoryNum',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          }
        },

        // 打印的列表
        printTablesProp: {
          wlWholesaleOrderGoodsMapList: {
            tableName: 'wlWholesaleOrderGoodsMapList',
            showSummary: true,
            summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
            columns: [
              {
                label: '序号',
                prop: 'indexShow',
                width: '50',
                align: "center"
              },
              {
                label: '条码',
                prop: 'barCode',
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '单位',
                width: '90',
                prop: 'unitName',
                align: "center"
              },
              {
                label: '自编码',
                width: '125',
                prop: 'artNo',
                align: "center"
              },
              {
                label: '数量',
                width: '90',
                prop: 'goodsCount',
                align: "center"
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsCount',
                align: "center"
              },
              {
                label: '原价',
                width: '90',
                prop: 'beforePrince',
                align: "center"
              },
              {
                label: '原价金额',
                width: '90',
                prop: 'beforeAmt',
                align: "center"
              },
              {
                label: '折扣',
                width: '90',
                prop: 'discountRate',
                align: "center"
              },
              {
                label: '折扣价格',
                width: '90',
                prop: 'discountPrince',
                align: "center"
              },
              {
                label: '小计金额',
                width: '90',
                prop: 'discountAmt',
                align: "center"
              },
              {
                label: '系统库存',
                width: '90',
                prop: 'inventoryNum',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          },
        },
        url: api.wholesale.wholesaleSales
      },
      //批发退货
      wholeasleReturnDetailColumns:  {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '100px',
          top: '0',
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
          },
          {
            label: "批发门店",
            prop: "storeName",
          }, {
            label: '批发客户',
            prop: 'wholesaleCustomerName',
          }, {
            label: "仓库",
            prop: "warehouseName",
          }, {
            label: '经手人',
            prop: 'salesman',
          },
          {
            label: '批发销售单',
            type: 'select',
            prop: 'wholesaleOrderNo',
          }, {
            label: '备注',
            prop: 'remarks',
          }],
        tablesProp: {
          wlWholesaleOrderGoodsMapList: {
            url: api.wholesale.wholesaleQuery + "/page",
            height: this.detailHeight,
            indexShow: true,
            showSummary: true,
            tableName: "wlWholesaleOrderGoodsMapList",
            summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '单位',
                width: '90',
                prop: 'unitName',
                align: "center"
              },
              {
                label: '自编码',
                width: '125',
                prop: 'artNo',
                align: "center"
              },
              {
                label: '数量',
                width: '90',
                prop: 'goodsCount',
                type: 'inputNumber',
                align: "center"
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsCount',
                align: "center"
              },
              {
                label: '原价',
                width: '90',
                prop: 'beforePrince',
                align: "center"
              },
              {
                label: '原价金额',
                width: '90',
                prop: 'beforeAmt',
                align: "center"
              },
              {
                label: '折扣',
                width: '90',
                prop: 'discountRate',
                align: "center"
              },
              {
                label: '折扣价格',
                width: '90',
                prop: 'discountPrince',
                align: "center"
              },
              {
                label: '小计金额',
                width: '90',
                prop: 'discountAmt',
                align: "center"
              },
              {
                label: '系统库存',
                width: '90',
                prop: 'inventoryNum',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          }
        },

        // 打印的列表
        printTablesProp: {
          wlWholesaleOrderGoodsMapList: {
            tableName: 'wlWholesaleOrderGoodsMapList',
            showSummary: true,
            summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '单位',
                width: '90',
                prop: 'unitName',
                align: "center"
              },
              {
                label: '自编码',
                width: '125',
                prop: 'artNo',
                align: "center"
              },
              {
                label: '数量',
                width: '90',
                prop: 'goodsCount',
                type: 'inputNumber',
                align: "center"
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsCount',
                align: "center"
              },
              {
                label: '原价',
                width: '90',
                prop: 'beforePrince',
                align: "center"
              },
              {
                label: '原价金额',
                width: '90',
                prop: 'beforeAmt',
                align: "center"
              },
              {
                label: '折扣',
                width: '90',
                prop: 'discountRate',
                align: "center"
              },
              {
                label: '折扣价格',
                width: '90',
                prop: 'discountPrince',
                align: "center"
              },
              {
                label: '小计金额',
                width: '90',
                prop: 'discountAmt',
                align: "center"
              },
              {
                label: '系统库存',
                width: '90',
                prop: 'inventoryNum',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          },
        },
        url: api.wholesale.wholesaleReturn
      },
      // 调拨详情
      transferringDetailColumns:  {
        statusOption: {
          prop: 'auditStatus',
          statusImg: {
            10: '/static/un-check.png',
            20: '/static/checked.png',
          },
          right: '100px',
          top: '0'
        },
        span: 8,
        labelWidth: '130',
        columns: [
          {
            label: '业务单号：',
            prop: 'orderNo',
          }, {
            label: '引用单号：',
            prop: 'requireOrderNo',
          }, {
            label: '调出门店：',
            prop: 'deliverStoreName',
          },
          {
            label: '调出仓库',
            prop: 'deliverWarehouseName',
          },
          {
            label: '调入门店：',
            prop: 'requireStoreName',
          },
          {
            label: '调入仓库',
            prop: 'requireWarehouseName',
          },
          {
            label: '经手人：',
            prop: 'handlerName',
          }, {
            label: '备注：',
            prop: 'remarks',
          }],
        tablesProp: {
          goodsMapMVOList: {
            url: api.delivery.transferringGoods + "/page",
            height: this.detailHeight,
            indexShow: true,
            showSummary: true,
            summaryColumns: ['goodsNum', 'subtotalAmount'],
            tableName: 'goodsMapMVOList',
            columns: [
              {
                label: '条码',
                prop: 'goodsBarCode',
                align: 'center',
                width: '180'
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                align: 'center',
                width: '150'
              },
              {
                label: '规格',
                prop: 'goodsSpecs',
                align: 'center',
                width: '70'
              },
              {
                label: '单位',
                prop: 'goodsUnitName',
                align: 'center',
                width: '70'
              },
              {
                label: '类别',
                prop: 'goodsCategoryName',
                width: '120',
                align: "center"
              },
              {
                label: '品牌',
                prop: 'goodsBrandName',
                align: 'center',
                width: '120'
              },
              {
                label: '配送价',
                prop: 'deliveryPrice',
                align: 'center',
                width: '100'
              },
              {
                label: '数量',
                prop: 'goodsNum',
                align: 'center',
                width: '100'
              },
              {
                label: '小计金额',
                prop: 'subtotalAmount',
                align: 'center',
                width: '100'
              },
              {
                label: '当前门店库存',
                prop: 'goodsInventoryNum',
                align: 'center',
                width: '135'
              },
              {
                label: '零售价',
                prop: 'retailPrice',
                align: 'center',
                width: '100'
              },
              {
                label: '备注',
                prop: 'remarks',
                align: 'center',
                width: '150'
              }
            ]
          }
        },
        // 打印的列表
        printTablesProp: {
          goodsMapMVOList: {
            summaryColumns: ['goodsNum', 'subtotalAmount'],
            tableName: 'goodsMapMVOList',
            showSummary: true,
            columns: [
              {
                label: '条码',
                prop: 'goodsBarCode',
                align: 'center',
                width: '180'
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                align: 'center',
                width: '150'
              },
              {
                label: '规格',
                prop: 'goodsSpecs',
                align: 'center',
                width: '120'
              },
              {
                label: '单位',
                prop: 'goodsUnitName',
                align: 'center',
                width: '100'
              },
              {
                label: '类别',
                prop: 'goodsCategoryName',
                width: '120',
                align: "center"
              },
              {
                label: '品牌',
                prop: 'goodsBrandName',
                align: 'center',
                width: '120'
              },
              {
                label: '零售价',
                prop: 'retailPrice',
                align: 'center',
                width: '100'
              },
              {
                label: '配送价',
                prop: 'deliveryPrice',
                align: 'center',
                width: '100'
              },
              {
                label: '数量',
                prop: 'goodsNum',
                align: 'center',
                width: '100'
              },
              {
                label: '小计金额',
                prop: 'subtotalAmount',
                align: 'center',
                width: '100'
              },
              {
                label: '当前门店库存',
                prop: 'goodsInventoryNum',
                align: 'center',
                width: '135'
              },
              {
                label: '备注',
                prop: 'remarks',
                align: 'center',
                width: '90'
              }
            ]
          },
        },
        url: api.delivery.transferringDetails
      },
      //配送详情
      DeliverDetailColumns: {
        statusOption: {
          prop: 'auditStatus',
          statusImg: {
            10: '/static/un-check.png',
            20: '/static/checked.png',
          },
          right: '100px',
          top: '0px'
        },
        span: 8,
        labelWidth: '130',
        columns: [
          {
            label: '业务单号：',
            prop: 'orderNo',
          }, {
            label: '引用单号：',
            prop: 'allocationOrderNo',
          }, {
            label: '配送门店',
            prop: 'distributionStoreName',
          },
          {
            label: '配送仓库',
            prop: 'distributionWarehouseName',
          },
          {
            label: '收货门店',
            prop: 'receivingStoreName',
          },
          {
            label: '收货仓库',
            prop: 'receivingWarehouseName',
          },
          {
            label: '经手人：',
            prop: 'handlerName',
          }],
        tablesProp: {
          goodsMapMVOList: {
            url: api.delivery.deliverGoods + "/page",
            height: this.detailHeight,
            indexShow: true,
            summaryColumns: ['goodsNum', 'subtotalAmount'],
            tableName: 'goodsMapMVOList',
            showSummary: true,
            columns: [
              {
                label: '条码',
                prop: 'goodsBarCode',
                align: 'center',
                width: '180'
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                align: 'center',
                width: '150'
              },
              {
                label: '规格',
                prop: 'goodsSpecs',
                align: 'center',
                width: '70'
              },
              {
                label: '单位',
                prop: 'goodsUnitName',
                align: 'center',
                width: '70'
              },
              {
                label: '类别',
                prop: 'goodsCategoryName',
                width: '120',
                align: 'center',
              },
              {
                label: '品牌',
                prop: 'goodsBrandName',
                align: 'center',
                width: '120'
              },
              {
                label: '配送价',
                prop: 'deliveryPrice',
                align: 'center',
                width: '100'
              },
              {
                label: '数量',
                prop: 'goodsNum',
                align: 'center',
                width: '100'
              },
              {
                label: '差异数量',
                width: '100',
                prop: 'differenceNum',
                align: 'center',
              },
              {
                label: '小计金额',
                prop: 'subtotalAmount',
                align: 'center',
                width: '100'
              },
              {
                label: '当前门店库存',
                prop: 'goodsInventoryNum',
                align: 'center',
                width: '135'
              },
              {
                label: '零售价',
                prop: 'retailPrice',
                align: 'center',
                width: '100'
              },
              {
                label: '备注',
                prop: 'remarks',
                align: 'center',
                width: '150'
              }
            ]
          }
        },
        // 打印的列表
        printTablesProp: {
          goodsMapMVOList: {
            summaryColumns: ['goodsNum', 'subtotalAmount'],
            tableName: 'goodsMapMVOList',
            showSummary: true,
            columns: [
              {
                label: '条码',
                prop: 'goodsBarCode',
                align: 'center',
                width: '180'
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                align: 'center',
                width: '150'
              },
              {
                label: '规格',
                prop: 'goodsSpecs',
                align: 'center',
                width: '120'
              },
              {
                label: '单位',
                prop: 'goodsUnitName',
                align: 'center',
                width: '100'
              },
              {
                label: '类别',
                prop: 'goodsCategoryName',
                width: '120',
                align: "center"
              },
              {
                label: '品牌',
                prop: 'goodsBrandName',
                align: 'center',
                width: '120'
              },
              {
                label: '配送价',
                prop: 'deliveryPrice',
                align: 'center',
                width: '100'
              },
              {
                label: '数量',
                prop: 'goodsNum',
                align: 'center',
                width: '100'
              },
              {
                label: '小计金额',
                prop: 'subtotalAmount',
                align: 'center',
                width: '100'
              },
              {
                label: '当前门店库存',
                prop: 'goodsInventoryNum',
                align: 'center',
                width: '135'
              },
              {
                label: '零售价',
                prop: 'retailPrice',
                align: 'center',
                width: '100'
              },
              {
                label: '备注',
                prop: 'remarks',
                align: 'center',
                width: '90'
              }
            ]
          },
        },
        url: api.delivery.deliverDetails
      },
      // 详情
      businessDetailColumns: {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '350px',
          top: '30px'
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
            span: 12,
          },
          {
            label: '仓库',
            prop: 'warehouseName',
            span: 12,
          }, {
            label: '原因',
            type: 'select',
            prop: 'cause',
            enumData: this.$utils.getCacheStatus('weAdjustInventoryOrder.cause'),
            span: 12,
          }, {
            label: '出入库',
            type: 'select',
            enumData: this.$utils.getCacheStatus('weAdjustInventoryOrder.type'),
            prop: 'type',
            span: 12,
          }, {
            label: '备注',
            type: 'input',
            prop: 'remarks',
            span: 12,
          }],
        tablesProp: {
          weAdjustGoodsMapMVOList: {
            url: api.warehouse.adjustGoodsMap + "/page",
            height: this.detailHeight,
            indexShow: true,
            tableName: "weAdjustGoodsMapMVOList",
            showSummary: true,
            summaryColumns: ['goodsNum', 'totalPrice'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                type: 'more',
                callback: this.getInfo,
                align: 'center',
                width: '250'
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                align: 'center',
                width: '250'
              },
              {
                label: '进货规格',
                prop: 'specs',
                align: 'center',
                width: '250'
              },
              {
                label: '价格',
                prop: 'purchasePrice',
                align: 'center',
                width: '250'
              },
              {
                label: '数量',
                prop: 'goodsNum',
                type: 'inputNumber',
                change: this.numChange,
                align: 'center',
                width: '250'
              },
              {
                label: '小计金额',
                prop: 'totalPrice',
                align: 'center',
                width: '250'
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '300',
                align: 'center'
              },
            ],
          }
        },

        printTablesProp: {
          weAdjustGoodsMapMVOList: {
            tableName: 'weAdjustGoodsMapMVOList',
            showSummary: true,
            summaryColumns: ['goodsNum', 'totalPrice'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                type: 'more',
                callback: this.getInfo,
                align: 'center',
                width: '250'
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                align: 'center',
                width: '250'
              },
              {
                label: '进货规格',
                prop: 'specs',
                align: 'center',
                width: '250'
              },
              {
                label: '价格',
                prop: 'purchasePrice',
                align: 'center',
                width: '250'
              },
              {
                label: '数量',
                prop: 'goodsNum',
                type: 'inputNumber',
                change: this.numChange,
                align: 'center',
                width: '250'
              },
              {
                label: '小计金额',
                prop: 'totalPrice',
                align: 'center',
                width: '250'
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '300',
                align: 'center'
              },
            ],
          },
        },
        url: api.warehouse.adjustInventory
      },
      // 详情
      goodsDetailColumns: {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '350px',
          top: '30px'
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '仓库',
            prop: 'warehouseName',
            span: 12,
          },
          {
            label: '盘点单批号',
            prop: 'batchOrderNo',
            span: 12,
          }, {
            label: '盘点范围',
            prop: 'type',
            span: 12,
            enumData: this.$utils.getCacheStatus('weBatchNumberOrder.type')
          }, {
            label: '备注',
            prop: 'remarks',
            span: 12
          },
          {
            label: '盘点信息',
            prop: 'retaleInfo',
            span: 12,
          },],
        tablesProp: {
          weBlitemGoodsMapMVOList: {
            tableName: "weBlitemGoodsMapMVOList",
            showSummary: true,
            summaryColumns: ['blitemNum', 'amountInventory'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '230',
                align: 'center',
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                align: 'center',
                width: '230'
              },
              {
                label: '单位',
                prop: 'unitName',
                align: 'center',
                width: '120'
              },
              {
                label: '类别',
                prop: 'goodsCategoryName',
                align: 'center',
                width: '130'
              },
              {
                label: '品牌',
                prop: 'goodsBrandName',
                align: 'center',
                width: '150'
              },
              {
                label: '成本价',
                prop: 'purchasePrice',
                align: 'center',
                width: '110'
              },
              {
                label: '数量',
                width: '110',
                align: 'center',
                prop: 'blitemNum',
              },
              {
                label: '价格',
                prop: 'amountInventory',
                align: 'center',
                width: '110',
              },
              {
                label: '备注',
                prop: 'remarks',
                align: 'center',
                width: '220',
              },
            ],
          }
        },

        printTablesProp: {
          weBlitemGoodsMapMVOList: {
            tableName: 'weBlitemGoodsMapMVOList',
            showSummary: true,
            summaryColumns: ['blitemNum', 'amountInventory'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '230',
                align: 'center',
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                align: 'center',
                width: '230'
              },
              {
                label: '单位',
                prop: 'unitName',
                align: 'center',
                width: '120'
              },
              {
                label: '类别',
                prop: 'goodsCategoryName',
                align: 'center',
                width: '130'
              },
              {
                label: '品牌',
                prop: 'goodsBrandName',
                align: 'center',
                width: '150'
              },
              {
                label: '成本价',
                prop: 'purchasePrice',
                align: 'center',
                width: '110'
              },
              {
                label: '数量',
                width: '110',
                align: 'center',
                prop: 'blitemNum',
              },
              {
                label: '价格',
                prop: 'amountInventory',
                align: 'center',
                width: '110',
              },
              {
                label: '备注',
                prop: 'remarks',
                align: 'center',
                width: '220',
              },
            ],
          },
        },
        url: api.warehouse.blitem
      },
      //小票预览信息
      billReportListColumns: {
        title: {
          orderType: {
            label: '',
            prop: ''
          },
          orderNo: {
            label: '',
            prop: ''
          },
          lastModifyDttm: {
            label: '',
            prop: ''
          },
          mbMemberId: {
            label: '',
            prop: ''
          },
          cashierName: {
            label: '',
            prop: ''
          },
        },
        foot: {
          allPrice: {
            label: '',
            prop: ''
          },
          discountPrice: {
            label: '',
            prop: ''
          },
          amountReceived: {
            label: '',
            prop: ''
          },
          payType: {
            label: '',
            prop: ''
          },
        },
        columns: [
          {
            label: '名称',
            prop: 'goodsName',
            width: '20%',
          },
          {
            label: '原价',
            prop: 'retailPrice',
            width: '20%',
            enumData: this.$utils.getCacheStatus("soBillOrder.retailPrice")
          },
          {
            label: '单价',
            prop: 'unitPrice',
            width: '20%',
            enumData: this.$utils.getCacheStatus("soBillOrder.payType")
          },
          {
            label: '数量',
            prop: 'goodsNum',
            width: '20%',
          },
          {
            label: '合计',
            prop: 'payPrice',
            width: '20%',
          },
        ],
        list: [],
      },

      //积分兑换预览信息
      integralExchangeListColumns: {
        title: {
          orderTypeDesc: {
            label: '',
            prop: ''
          },
          orderNo: {
            label: '',
            prop: ''
          },
          cardNum: {
            label: '',
            prop: ''
          },
          memberName: {
            label: '',
            prop: ''
          },
          lastModifyDttm: {
            label: '',
            prop: ''
          },
        },
        foot: {
          useIntegral: {
            label: '',
            prop: ''
          },
          usaIntegral: {
            label: '',
            prop: ''
          },
        },
        columns: [
          {
            label: '条码',
            prop: 'barCode',
            width: '15%',
          },
          {
            label: '名称',
            prop: 'goodsName',
            width: '20%',
          },
          {
            label: '原价',
            prop: 'retailPrice',
            width: '15%',
          },
          {
            label: '积分',
            prop: 'needIntegral',
            width: '15%',
          },
          {
            label: '数量',
            prop: 'exchangeNum',
            width: '10%',
          },
          {
            label: '合计',
            prop: 'consumptionIntegral',
            width: '15%',
          },
        ],
        list: [],
      },
    };
  },
  created() {
    this.setStore(this.searchOptions.complex)
    if (this.$utils.getSysUser().storeId) {
      this.storeChange(this.$utils.getSysUser())
    }
  },
  methods: {
    // 搜索重置
    searchReset() {
      if (!this.$utils.getSysUser().storeId) {
        this.searchOptions.complex.filter(item => item.prop === 'brandId')[0].data = []
        this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
      }
    },
    // 选择门店
    storeChange(form) {
      form.brandId = '';
      form.supplierId = '';
      this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.searchOptions.complex.filter(item => item.prop === 'brandId')[0].data = data.data;
        }
      });
      this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
        }
      })
    },
    goOrderDetail(row) {
      if (row.businessType === 10) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.stockDetailColumns);
        const {href} = this.$router.resolve({
          name: "stockDetail",
          query: {id: row.retaleId},
        });
        window.open(href, "_blank");
      } else if (row.businessType === 20) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.purchaseReturnDetailColumns);
        const {href} = this.$router.resolve({
          name: "stockDetail",
          query: {id: row.retaleId},
        });
        window.open(href, "_blank");
      } else if (row.businessType === 30) {
        //库存调整单
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.businessDetailColumns);
        const {href} = this.$router.resolve({
          name: "BusinessDetail",
          query: {id: row.retaleId},
        });
        window.open(href, "_blank");
      } else if (row.businessType === 50) {
        //调拨单
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.transferringDetailColumns);
        const {href} = this.$router.resolve({
          name: "transferringDetail",
          query: {id: row.retaleId},
        });
        window.open(href, "_blank");
      } else if (row.businessType === 55) {
        //配送单
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.DeliverDetailColumns);
        const {href} = this.$router.resolve({
          name: "deliverDetail",
          query: {id: row.retaleId},
        });
        window.open(href, "_blank");
      } else if (row.businessType === 120) {
        //库存盘点
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.goodsDetailColumns);
        const {href} = this.$router.resolve({
          name: "difference",
          query: {id: row.retaleId},
        });
        window.open(href, "_blank");
      } else if (row.businessType === 70) {
        //收银机 小票预览
        // this.$message({message: '收银机销售无订单详情!', type: 'info'})
        this.$axios
          .fetchGet(api.retail.billDetail + '?id=' + row.retaleId, {})
          .then((res) => {
            if (res.code === 200) {
              this.billShow = true
              //订单类型取值
              let soBillOrderOrderType = JSON.parse(localStorage.getItem('STATUSDATA'))['soBillOrder.orderType']
              soBillOrderOrderType.forEach(v => {
                if (v.value == res.data.orderType) {
                  res.data.orderType = v.label
                }
              })
              this.billReportListColumns.title = {
                orderType: {label: '订单类型', prop: res.data.orderType},
                orderNo: {label: '订单单号', prop: res.data.orderNo},
                lastModifyDttm: {label: '购买时间', prop: res.data.lastModifyDttm},
                mbMemberId: {label: '会员名称', prop: res.data.memebrName},
                cashierName: {label: '收银员工', prop: res.data.cashierName}
              }
              //支付方式取值
              let soBillOrderPaytype = JSON.parse(localStorage.getItem('STATUSDATA'))['soBillOrder.payType']
              soBillOrderPaytype.forEach(v => {
                if (v.value == res.data.payType) {
                  res.data.payType = v.label
                }
              })
              this.billReportListColumns.foot = {
                allPrice: {label: '合计金额', prop: res.data.allPrice},
                discountPrice: {label: '优惠金额', prop: res.data.discountPrice},
                amountReceived: {label: '实收金额', prop: res.data.amountReceived},
                payType: {label: '支付方式', prop: res.data.payType},
              }
              this.billReportListColumns.list = res.data.soBillOrderGoodsMapMVOList
            } else {
              this.$message({
                type: "error",
                message: res.errorMsg || '请求错误！'
              })
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (row.businessType === 80) {
        //批发销售
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.salesDetailColumns);
        const {href} = this.$router.resolve({
          name: "SalesDetail",
          query: {id: row.retaleId},
        });
        window.open(href, "_blank");
      } else if (row.businessType === 90) {
        //批发退货
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.wholeasleReturnDetailColumns);
        const {href} = this.$router.resolve({
          name: "wholeasleReturnDetail",
          query: {id: row.retaleId},
        });
        window.open(href, "_blank");
      } else if (row.businessType === 100) {
        //日清
        this.$message({message: '日清无订单详情!', type: 'info'})
      } else if (row.businessType === 110) {
        //调价
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.pdadjapDetailColumns);
        const {href} = this.$router.resolve({
          name: "pdadjapDetail",
          query: {id: row.retaleId},
        });
        window.open(href, "_blank");
      } else if (row.businessType === 130) {
        //建档库存
        this.$message({message: '建档库存无订单详情!', type: 'info'})
      } else if (row.businessType === 140) {

        this.$axios
          .fetchPost(api.member.mbIntegralGiftDetail, {orderNo: row.orderNo})
          .then((res) => {
            if (res.code === 200) {
              this.memberShow = true
              //订单类型取值
              this.integralExchangeListColumns.title = {
                orderTypeDesc: {label: '订单类型', prop: res.data.orderTypeDesc},
                orderNo: {label: '订单单号', prop: res.data.orderNo},
                cardNum: {label: '会员卡号', prop: res.data.artNo},
                memberName: {label: '会员姓名', prop: res.data.memberName},
                lastModifyDttm: {label: '兑换时间', prop: res.data.createDttm},
              };
              //支付方式取值
              this.integralExchangeListColumns.foot = {
                useIntegral: {label: '本次使用积分合计', prop: res.data.useIntegral.toFixed(2)},
                usaIntegral: {label: '剩余积分', prop: res.data.usaIntegral.toFixed(2)},
              };
              let giftList = [];
              res.data.giftList.map(item => {
                let obj = {
                  barCode: item.barCode,
                  goodsName: item.goodsName,
                  retailPrice: item.retailPrice,
                  needIntegral: item.needIntegral.toFixed(2),
                  exchangeNum: item.exchangeNum,
                  consumptionIntegral: item.consumptionIntegral.toFixed(2),
                };
                giftList.push(obj);
              });

              this.integralExchangeListColumns.list = giftList;
            } else {
              this.$message({
                type: "error",
                message: res.errorMsg || '请求错误！'
              })
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let params = this.$refs["detailTemplate"].getCurrentParams();
      this.$axios.PostBlob(api.warehouse.detailGoodsExport, params).then(res => {
        if (res.status === 200) {
          const fileName = '出入库明细' + this.$utils.getDateTime() + ".xlsx";
          console.log(fileName);
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/page/warehouse/QueryDetail.vue